import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import differenceWith from 'lodash/differenceWith';
import isEqual from 'lodash/isEqual';
import { doc } from '@atlaskit/adf-utils/builders';
import { traverse } from '@atlaskit/adf-utils/traverse';
var getADFValidator = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _yield$import, validator;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return import( /* webpackChunkName: "async-adf-validator" */'@atlaskit/adf-utils/validator');
        case 2:
          _yield$import = _context.sent;
          validator = _yield$import.validator;
          return _context.abrupt("return", validator);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getADFValidator() {
    return _ref.apply(this, arguments);
  };
}();
var validateAdfExternalUrls = function validateAdfExternalUrls(adf) {
  try {
    traverse(adf, {
      media: function media(node) {
        var _node$attrs, _node$attrs2;
        if (((_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.type) === 'external' && ((_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.url) !== undefined) {
          throw new Error('Cannot contain external images');
        }
      },
      blockCard: function blockCard() {
        throw new Error('Cannot contain blockCard');
      },
      embedCard: function embedCard() {
        throw new Error('Cannot contain embedCard');
      }
    });
    return true;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (err) {
    return false;
  }
};
export var validateAdfProhibitedNodes = function validateAdfProhibitedNodes(newValue, currentValue) {
  // If there is no user input or defaultValue set, we just validate the `externalValue` directly
  if (!currentValue || !currentValue.content.length) {
    return validateAdfExternalUrls(newValue);
  }

  // Find the diff nodes between the new value and the current value
  var foundDiffNodes = differenceWith(newValue.content, currentValue.content, isEqual);

  // Format `foundDiffNodes` into a valid ADF doc
  var formattedDiffAdf = doc.apply(void 0, _toConsumableArray(foundDiffNodes));
  return validateAdfExternalUrls(formattedDiffAdf);
};
export var isValidADF = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref2) {
    var newValue, currentValue, validator, validate, isValidAdfNewValue, isValidAdf;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          newValue = _ref2.newValue, currentValue = _ref2.currentValue;
          _context2.next = 3;
          return getADFValidator();
        case 3:
          validator = _context2.sent;
          validate = validator();
          _context2.prev = 5;
          isValidAdfNewValue =
          // Additionaly to ADF validator it chekcs version property since ADF validator checks only existance of it.
          Object.hasOwnProperty.call(newValue, 'version') && typeof newValue.version === 'number' && !Number.isNaN(newValue.version) && validate(newValue).valid;
          isValidAdf = isValidAdfNewValue && validateAdfProhibitedNodes(newValue, currentValue);
          return _context2.abrupt("return", isValidAdf);
        case 11:
          _context2.prev = 11;
          _context2.t0 = _context2["catch"](5);
          return _context2.abrupt("return", false);
        case 14:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[5, 11]]);
  }));
  return function isValidADF(_x) {
    return _ref3.apply(this, arguments);
  };
}();